export default "__VITE_ASSET__E08I0NYBSQBissyqM$dyHQ__ 480w, __VITE_ASSET__fQyoR3m0eA3DLqol7kyoXA__ 768w, __VITE_ASSET__fN3GBDImFL4syCUWbqabiA__ 1200w";